import axiosInstance from 'core/network/axiosInstance'

export interface LoginApiResponse {
  access_token: string
  refresh_token: string
  expires_in: number
}

export interface MeApiResponse {
  user_id: string
  email: string
  role: string
  permissions: string[]
}

export interface SelfApiResponse {
  id: string
  name: string
  role: string
  phone: string
  email: string
  status: string
  created_at: string
  updated_at: string
}

class AuthApiDatasource {
  async login(email: string, password: string): Promise<LoginApiResponse> {
    const { data } = await axiosInstance.post<LoginApiResponse>('/api/v1/login', { email, password })
    return data
  }

  // Lightweight — role + permissions parsed straight from the JWT, no DB lookup.
  async getMe(): Promise<MeApiResponse> {
    const { data } = await axiosInstance.get<MeApiResponse>('/api/v1/me')
    return data
  }

  // Full profile — name, phone, status, timestamps.
  async getSelf(): Promise<SelfApiResponse> {
    const { data } = await axiosInstance.get<SelfApiResponse>('/api/v1/users/self')
    return data
  }

  async resetPassword(email: string, newPassword: string): Promise<void> {
    await axiosInstance.post('/api/v1/forgot-password', { email, new_password: newPassword })
  }

  async refreshToken(refreshToken: string): Promise<LoginApiResponse> {
    const { data } = await axiosInstance.post<LoginApiResponse>('/api/v1/refresh-token', {
      refresh_token: refreshToken,
    })
    return data
  }
}

export const authApiDatasource = new AuthApiDatasource()
